module.exports = __webpack_public_path__ + "media/images/items/static-4-0e2c391686fc6defcfd9ece5422ead60.jpg";